<template>
    <div class="hooper">
        <card :card="card" :hide="false" :disableSwipe="true"></card>
        <vue-swipe-component class="swipe-component" :card="card"></vue-swipe-component>
    </div>
</template>

<script>
    import Card from "../components/card";
    import VueSwipeComponent from "../components/vue-swipe-component";

    export default {
        name: "LoanRequest",
        props: ['id','back'],
        components: {
            VueSwipeComponent,
            Card
        },
        data() {
            return {
                card: {}
            }
        },
        methods: {
            getRequest(loan) {
                const vm = this;
                vm.axios.get(`${vm.$host}/match/${loan}`)
                    .then(function (res) {
                        let dat = res.data;
                        if (dat.due === null) {
                            dat.due = "No due date"
                        } else {
                            let dueDate = new Date(dat.due);
                            dat.due = "Due on " + dueDate.toDateString();
                        }
                        vm.card = dat;
                    }).catch(function (err) {
                        if(err.response.status === 404) {
                            vm.$router.push({name: 'PageNotFound'})
                        } else {
                            alert(err);
                        }
                    });
            },
            goBack() {
                this.$router.push({ path: `/` });
            }
        },
        metaInfo() {
            return {
                title: this.card.headline,
                meta: [
                    {
                        property: 'description',
                        content: this.card.headline
                    },
                    {
                        property: 'image',
                        content: this.card.thumb
                    },
                    {
                        property: 'name',
                        content: this.card.headline
                    },
                    {
                        property: 'og:title',
                        content: this.card.headline,
                        template: '%s | Flapp Match',
                        vmid: 'og:title'
                    },
                    {
                        property: 'og:description',
                        content: 'Help out a friend with their loan request!',
                        vmid: 'og:description'
                    },
                    {
                        property: 'og:image',
                        content: this.card.thumb,
                        vmid: 'og:image'
                    },
                    {
                        property: 'og:site_name',
                        content: 'Flapp Match',
                        vmid: 'og:site_name'
                    },
                    {
                        property: 'og:video',
                        content: this.card.video_url,
                        vmid: 'og:video'
                    },
                    {
                        property: 'og:video:url',
                        content: this.card.video_url,
                        vmid: 'og:video:url'
                    },
                    {
                        property: 'og:video:secure_url',
                        content: this.card.video_url,
                        vmid: 'og:video:secure_url'
                    },
                    {
                        property: 'og:video:type',
                        content: 'video/mp4',
                        vmid: 'og:video:type'
                    },
                    {
                        property: 'og:video:width',
                        content: '405',
                        vmid: 'og:video:width'
                    },
                    {
                        property: 'og:video:height',
                        content: '720',
                        vmid: 'og:video:height'
                    },
                    {
                        property: 'og:url',
                        content: window.location.href,
                        vmid: 'og:url'
                    },
                    {
                        property: 'og:type',
                        content: 'website',
                        vmid: 'og:type'
                    },
                    {
                        property: 'og:image:width',
                        content: '180',
                        vmid: 'og:image:width'
                    },
                    {
                        property: 'og:image:height',
                        content: '320',
                        vmid: 'og:image:width'
                    },
                    {
                        property: 'fb:app_id',
                        content: '431281457563641'
                    },
                ]
            }
        },
        mounted() {
            this.getRequest(this.$props.id)
        }
    }
</script>

<style scoped>
    .hooper {
        position: fixed;
        top: 48px;
        height: calc(81vh - 48px);
    }

    .swipe-component {
        position: absolute;
        z-index: 2;
    }
</style>